<template>
  <div class="app-wrapper">
    <NavBar :className="'auto-width'"/>
    <div class="control-part">
      <Sidebar class="sidebar-container"/>
      <div class="main-container">
        <AppMain/>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/public/NavBar'
import Sidebar from './components/Sidebar/index'
import ControlNavBar from './components/ControlNavBar'
import AppMain from './components/AppMain'

export default {
  name: 'Layout',
  components: {
    NavBar,
    ControlNavBar,
    Sidebar,
    AppMain
  },
  computed: {
  },
  methods: {

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/css/base.scss";
  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .control-part {
    height: 100%;
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/views/controlCenter/layout/layout.vue